<div class="flex flex-col justify-end items-center">
  <ng-container *ngFor="let scale of [0.25, 0.5, 0.75]">
    <hr class="hr-relative" [style.top.px]="tileHeight * scale" />
  </ng-container>
  <div
    class="bar-on-top fill-width flex flex-col justify-end items-center"
    [style.height.px]="tileHeight"
  >
    <ng-container *ngFor="let chartBarPart of barModel.chartBarParts; index as i">
      <div
        *ngIf="chartBarPart.color"
        class="bar-width"
        [ngClass]="chartBarPart.color"
        [style.height.px]="getHeight(chartBarPart.value)"
      ></div>
    </ng-container>
  </div>
  <hr />
  <p class="bar-label" [ngClass]="{ 'bar-label-hide-xs': hideDesignationKey }">
    {{ barModel.designationKey | translate }}
  </p>
</div>
